import React from 'react';
import './about.css';

const myDate = new Date().getFullYear();

function About() {
  return (
    <div className='about-container'>
      <div id='jumbotron' className='about-jumbotron jumbotron jumbotron-fluid d-flex justify-content-center'>
        <div className='image-container'>
          <img
            className='image'
            src='https://res.cloudinary.com/dytnpjxrd/image/upload/v1717118826/imageedit_1_3884076213_tbvd8u.png'
            alt='me'
          />
        </div>
      </div>

      <div className='container article-container'>
        <article>
          <h3 className='text-center article-title'>From Self-Taught Coder to Software Engineer: A Journey into Generative AI, LLMs, and Web Development</h3>
          <br />
          <div className='article-para'>
          Welcome to my personal portfolio website! I'm Marsiya Issah, a passionate Software Engineer specializing in Generative AI, Large Language Models (LLMs), and Web Development. With a fervent love for technology and a drive to innovate, I'm constantly seeking new challenges and pushing the boundaries of what's possible in the world of software development.
          </div>
          <br />
          <div className='article-para'>
        My journey into the realm of coding began with a spark of curiosity and a determination to learn. Over the years, I've honed my skills through hands-on experience and a commitment to lifelong learning. From mastering the intricacies of natural language processing to crafting elegant user interfaces with React.js, I thrive on tackling complex problems and transforming ideas into reality.
          </div>
          <br />
          <div className='article-para'>
            As a Software Engineer, I believe in the power of technology to drive positive change and improve lives. Whether I'm collaborating with a team to develop cutting-edge solutions or embarking on solo projects to explore new technologies, my goal is always the same: to create innovative software that makes a difference.
          </div>

          <br />
          <div className='article-para'>
           I am constanlty building and updating my portfolio 🧠🐱‍💻🤖🚗🚀 but I invite you to explore my work, delve into my projects, and discover the passion and creativity that drive me as a Software Engineer. From AI-powered applications to responsive web interfaces, each project represents a unique opportunity to innovate, iterate, and inspire.
          </div>

          <br />
          <div className='article-para'>
            Thank you for visiting, and I look forward to connecting with you!
          </div>
          {/* <div className="mt-5 text-center">
						<a
							data-toggle="tooltip"
							data-placement="right"
							title="Click toopen and download"
							className="all-btn"
							href="https://drive.google.com/file/d/1bYhwJCNuEjEfw2RHAlPqNVwoSJrn-hEk/view?usp=sharing"
							target="_blank"
							rel="noreferrer"
						>
							RESUME
						</a>
					</div> */}
        </article>
      </div>

      <section id='contact' className='d-flex flex-column justify-content-center align-items-center text-center'>
        <div className='contact-header'>
          <h2>Let's work together...</h2>
          <p>
            <i>Reach me on any of these platforms</i>
          </p>
        </div>
        <div className='contact-links'>
          <button type='button' id='contact-link-btn' data-toggle='tooltip' data-placement='right' title='Github'>
            <a href='https://github.com/Mar-Issah' target='_blank' rel='noreferrer'>
              <i className='fab fa-github'></i>
            </a>
          </button>
          <button type='button' id='contact-link-btn' data-toggle='tooltip' data-placement='right' title='CodePen'>
            <a href='https://github.com/Mar-Issah' target='_blank' rel='noreferrer'>
              <i className='fab fa-codepen'></i>
            </a>
          </button>

          <button type='button' id='contact-link-btn' data-toggle='tooltip' data-placement='right' title='Gmail'>
            <a href='mailto:masy370@gmail.com' target='_blank' rel='noreferrer'>
              <i className='far fa-envelope'></i>
            </a>
          </button>

          <button type='button' id='contact-link-btn' data-toggle='tooltip' data-placement='right' title='Linkedin'>
            <a href='https://www.linkedin.com/in/marsiya-issah-8a481782/' target='_blank' rel='noreferrer'>
              <i className='fab fa-linkedin linkedin'></i>
            </a>
          </button>
        </div>
        <div className='move'>
          {/* this will give you the foating button to move up page to the top, fa 2x is a second class to increase the size of the button */}
          <span
            onClick={() => {
              document.documentElement.scrollTop = 0;
              document.body.scrollTop = 0;
            }}
          >
            <i className='fas fa-arrow-circle-up fa-2x'></i>
          </span>
        </div>
      </section>
      <footer>
        <div className='footer text-center'>
          <span>
            Copyright &copy; <span id='date'>{myDate} </span>| All rights reserved | designed and developed by
            <strong> Marsiya Issah</strong> |
          </span>
        </div>
      </footer>
    </div>
  );
}

export default About;
